"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNotFoundState = void 0;
exports.defaultNotFoundState = {
    title: 'Aiya! We can\'t seem to find the page you are looking for',
    caption: 'But we\'ve got thousands of others that can help you in your home search',
    or: 'or',
    tellUs: 'tell us',
    contactCaption: 'what happened and we\'ll get on it',
    searchForRent: 'Search For Rent',
    searchForSale: 'Search For Sale',
};
